module.exports = __webpack_public_path__ + "static/media/mobile_separator_02.61a3f293.webp";